import React from 'react';
import {
  Grid,
  TextField,
} from '@mui/material';

function AgentFormAdvancedSettings({
  metadataStr,
  mcpConfigStr,
  metadataError,
  mcpConfigError,
  onFieldChange // Asumiendo un handler (value, fieldName)
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Metadata (JSON)"
          multiline
          rows={4}
          fullWidth
          value={metadataStr}
          onChange={(e) => onFieldChange(e.target.value, 'metadataStr')} 
          error={!!metadataError}
          helperText={metadataError || "Dejar como '{}' si no se requiere"}
          sx={{ 
            '& .MuiInputBase-root': {
              fontFamily: 'monospace',
              fontSize: '0.9rem'
            }
          }}
        />
      </Grid>
      
      <Grid item xs={12}>
        <TextField
          label="MCP Config (JSON)"
          multiline
          rows={4}
          fullWidth
          value={mcpConfigStr}
          onChange={(e) => onFieldChange(e.target.value, 'mcpConfigStr')} 
          error={!!mcpConfigError}
          helperText={mcpConfigError || "Dejar como 'null' o vacío si no se requiere"}
          sx={{ 
            '& .MuiInputBase-root': {
              fontFamily: 'monospace',
              fontSize: '0.9rem'
            }
          }}
        />
      </Grid>
    </Grid>
  );
}

export default AgentFormAdvancedSettings; 